// test1492
(1492 && 0);
